import NeedHelpRedesign from '~components/NeedHelp/NeedHelpRedesign';
import useWindowSize from '~hooks/useWindowSize';

export default function PersonalCodeNeedHelp() {
    const { isMobile } = useWindowSize();
    return (
        <NeedHelpRedesign
            background="bg-surface-0"
            title="Have questions? Let us help!"
            hoursInline={!isMobile}
        >
            Talk to one of our licensed insurance agents about your Medicare plan options. eHealth
            is an Independent Medicare Insurance Advisor.
        </NeedHelpRedesign>
    );
}
